@if (photoType && !hideHeadingAndInstructions) {
  <h5 class="mt-3 text-capitalize">{{photoType === 'DEFAULT' ? product.title : photoType.toLowerCase()}} photos</h5>
}

@if (!hideHeadingAndInstructions) {
  <div class="mb-3">
    @if (!isWebsite) {
      <span>Drag and drop the images you'd like to use on the boxes</span>
    }
    @if (isWebsite) {
      <span>Drag and drop images into the boxes below. After adding and arranging your photos, click Create or Update to display them on your website.</span>
    }
  </div>
}

<div class="product-photos-container mb-5 px-3">
  <div cdkDropListGroup>
    <div
      cdkDropList
      cdkDropListOrientation="mixed"
      class="photo-grid"
      id="product-photos-drag"
      [cdkDropListData]="productPhotos"
      [cdkDropListDisabled]="readOnly"
      (cdkDropListDropped)="onDragAndDrop($event)"
      >
      @for (viewModel of productPhotos; track viewModel.id; let i = $index) {
        @if (showPageHeaders && viewModel.pageDisplay) {
          <h5 class="page-header">{{viewModel.pageDisplay}}</h5>
        }
        <div cdkDrag class="photo-item" [cdkDragDisabled]="readOnly">
          <lc-photo
            class="photo-card-container"
            [iconsPersist]="!readOnly"
            [viewModel]="viewModel"
            (click)="onOpenGallery(i)"
            (delete)="onDeletePhoto($event)"
            (edit)="onCropPhoto($event, i)"
            (portraitDisabled)="onPortraitDisabled($event)"
            (toggleFavorites)="onToggleFavorite($event)" />
        </div>
      }
    </div>
  </div>
</div>
